import { render, staticRenderFns } from "./BeeProgressCircular.vue?vue&type=template&id=22006eaa"
import script from "./BeeProgressCircular.vue?vue&type=script&lang=js"
export * from "./BeeProgressCircular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports